import Alpine from "alpinejs";
import { getQueryParam } from "@src/js/utils/http";
import config from "@src/js/config";
import { AssistantService } from "@src/js/services/assistantService";
Alpine.data("assistantDetail", () => ({
    ready: false,
    openAIAssistants: [],
    assistant: {},
    heygenAvatars: [],
    azureVoices: [],
    languages: [
        { label: "Bulgarian", value: "bg" },
        { label: "Chinese", value: "zh" },
        { label: "Czech", value: "cs" },
        { label: "Danish", value: "da" },
        { label: "Dutch", value: "nl" },
        { label: "English", value: "en" },
        { label: "Finnish", value: "fi" },
        { label: "French", value: "fr" },
        { label: "German", value: "de" },
        { label: "Greek", value: "el" },
        { label: "Hindi", value: "hi" },
        { label: "Hungarian", value: "hu" },
        { label: "Indonesian", value: "id" },
        { label: "Italian", value: "it" },
        { label: "Japanese", value: "ja" },
        { label: "Korean", value: "ko" },
        { label: "Malay", value: "ms" },
        { label: "Norwegian", value: "no" },
        { label: "Polish", value: "pl" },
        { label: "Portuguese", value: "pt" },
        { label: "Romanian", value: "ro" },
        { label: "Russian", value: "ru" },
        { label: "Slovak", value: "sk" },
        { label: "Spanish", value: "es" },
        { label: "Swedish", value: "sv" },
        { label: "Turkish", value: "tr" },
        { label: "Ukrainian", value: "uk" },
        { label: "Vietnamese", value: "vi" },
    ],
    qualities: ["low", "medium", "high"],
    emotions: ["excited", "serious", "friendly", "soothing", "broadcaster"],
    tab: 'general',
    runtimeMinutes: 0,
    runtimeSeconds: 0, // default tab
    assistants: [],
    heygenAvatarModal: {},
    azureVoiceModal: {},
    readyplayerAvatarModal: {},
    selectedHeygenAvatar: null,
    selectedAzureVoice: null,
    selectedReadyplayerAvatar: null,
    readyplayerAvatars: [
        {
            name: "James",
            id: "686a7d88a70935d6151be82d",
        },
        {
            name: "Hannah",
            id: "686a7e438bb684540fd81fbc",
        },
        {
            name: "Emma",
            id: "686a7e5b6959759fe750d69c",
        },
        {
            name: "Oliver",
            id: "686a7eb76959759fe750e1a4",
        },
        {
            name: "Lucas",
            id: "6870eeb7742cffebe6ab7d51",
        },
        {
            name: "Mia",
            id: "6870ef722b25d8c0900383b9",
        },
        {
            name: "William",
            id: "6870efe59d81d50db6b72ca8",
        },
        {
            name: "Charlotte",
            id: "6870f05d2b25d8c0900393c8",
        },
        {
            name: "Aragorn",
            id: "686a6450a70935d61519d8a2",
        }
    ],
    get filteredReadyplayerAvatars() {
        const search = (this.readyplayerAvatarModal.search || "").toLowerCase();
        return this.readyplayerAvatars.filter(a => a.name.toLowerCase().includes(search));
    },
    get filteredHeygenAvatars() {
        return this.heygenAvatars.filter(a => {
            const name = a.pose_name.toLowerCase();
            const search = this.heygenAvatarModal.search.toLowerCase();
            return !name.includes("look") && name.includes(search);
        });
    },
    get filteredAzureVoices() {
        const search = this.azureVoiceModal.search.toLowerCase();
        return this.azureVoices.filter((voice) => {
            return voice.Name.toLowerCase().includes(search) || (voice.Locale && voice.Locale.toLowerCase().includes(search));
        });
    },
    selectHeygenAvatar(avatar) {
        this.heygenAvatarModal.open = false;
        this.selectedHeygenAvatar = avatar;
        this.assistant.avatarId = avatar.avatar_id;
    },
    selectAzureVoice(voice) {
        this.azureVoiceModal.open = false;
        this.selectedAzureVoice = voice;
        this.assistant.azureVoiceId = voice.ShortName;
    },
    selectReadyplayerAvatar(avatar) {
        this.readyplayerAvatarModal.open = false;
        this.selectedReadyplayerAvatar = avatar;
        this.assistant.readyplayerAvatarId = avatar.id;
    },
    async init() {
        try {
            let shareKey = getQueryParam("key");
            this.heygenAvatarModal.search = "";
            this.azureVoiceModal.search = "";
            this.readyplayerAvatarModal.search = "";
            // Load avatar list
            const avatarRes = await fetch(config.API_URL + "chat/avatars");
            const avatarData = await avatarRes.json();
            this.heygenAvatars = avatarData.data || [];
            const allAssistants = await AssistantService.getAll();
            this.assistants = allAssistants.filter(a => a.shareKey !== shareKey);
            if (shareKey) {
                try {
                    const assistant = await AssistantService.getByShareKey(shareKey);
                    this.assistant = assistant;
                }
                catch (error) {
                    console.error('Failed to load assistant:', error);
                }
                const total = Number(this.assistant.runtimeSeconds);
                this.runtimeMinutes = Math.floor(total / 60);
                this.runtimeSeconds = total % 60;
                console.log("Loaded assistant:", this.assistant);
            }
            // if the assistant already has an avatar id set, then set the selected avatar to this
            if (this.assistant.avatarId) {
                this.selectedHeygenAvatar = this.heygenAvatars.find(a => a.avatar_id === this.assistant.avatarId) || null;
            }
            const response = await fetch("https://germanywestcentral.tts.speech.microsoft.com/cognitiveservices/voices/list", {
                method: "GET",
                headers: {
                    "Ocp-Apim-Subscription-Key": "4tX5nOt78tetgu4Ad2uZyHIDNcC5WskFaznkPwrdWyOiznC8FdOxJQQJ99BGACPV0roXJ3w3AAAYACOGdWRe"
                }
            });
            if (!response.ok) {
                console.error("Failed to fetch voices:", response.statusText);
            }
            else {
                const voices = await response.json();
                this.azureVoices = voices;
                // console.log("Loaded Azure voices:", this.azureVoices);
            }
            if (this.assistant.azureVoiceId) {
                this.selectedAzureVoice = this.azureVoices.find((v) => v.ShortName === this.assistant.azureVoiceId) || null;
            }
            if (this.assistant.readyplayerAvatarId) {
                this.selectedReadyplayerAvatar = this.readyplayerAvatars.find(a => a.id === this.assistant.readyplayerAvatarId) || null;
            }
            this.ready = true;
        }
        catch (err) {
            console.error("Failed to load data:", err);
        }
    },
    async saveAssistant() {
        try {
            const savedAssistant = await AssistantService.save(this.assistant);
            console.log('Assistant created successfully:', savedAssistant);
            // Redirect to assistant list or detail page
            window.location.href = '/assistants.html';
        }
        catch (error) {
            console.error('Error saving assistant:', error);
            alert('Failed to create assistant: ' + (error.message || 'Unknown error'));
        }
    },
}));
